<template>
    <div>
         <!-- 首次登录--完善基础信息 -->
          <div class="">
              <el-dialog
              :visible.sync="DialogUpdateNickname"
              :modal='false'
              :show-close='false'

              width="492px"
              top='35vh'
              custom-class='DialogScopeOver'
              center>
              <div  slot="title"  class="DialogrightClose" @click='DialogUpdateNicknameClose'>跳过</div>
              <div class="contentVal">
                  <div class="headerTopbox">
                      <img src="/static/room/updateNicename .png" alt="" srcset="">
                      <div class='topTitle'>
                        <div class="title">
                          完善基础信息
                        </div>
                        <div class="discript">
                          让大家可以更好的认识你，彰显你的与众不同
                        </div>
                      </div>
                  </div>
                  <div class="formData">
                    <div class="formItems">
                      <div class="nickNameLeft">昵称</div>
                       <el-input @change='blurinput' class="myinput" v-model="updateNameValue" placeholder="请输入内容">
                         <i v-if="updateNameValue.length == 0" class="el-icon-edit el-input__icon" slot="prefix"></i>
                       </el-input>
                    </div>
                    <div class="formItems">
                      <div  class="nickNameLeft">性别</div>
                      <div class="changegender">
                        <div class="genderBox" @click="changeGenter(1)">
                            <div class="headerimg">
                              <img class="default" src="/static/room/user_nan.png" alt="" srcset="">
                              <img v-if='genderIndex == 1' class="defaultsel" src="/static/room/selectOk.png" alt="" srcset="">
                            </div>
                            <span>男性</span>
                        </div>
                        <div class="genderBox"  @click="changeGenter(2)">
                            <div class="headerimg">
                              <img  class="default" src="/static/room/user_nv.png" alt="" srcset="">
                              <img v-if='genderIndex == 2' class="defaultsel" src="/static/room/selectOk.png" alt="" srcset="">
                            </div>
                            <span>女性</span>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <div class="summat" @click="UpdataName()" :class="isbtn || updateNameValue.length>0?'':'greey'">提交</div>
              </span>
            </el-dialog>
          </div>
    </div>
</template>

<script>
  import {modifyEx,modifyNickname } from '@/api/lz.js'
export default {
    inject: ["reload"],
    data(){
        return {
            DialogUpdateNickname:false,// 首次登录 修改
            updateNameValue:'',
            genderIndex:1,
            isbtn:false
        }
    },
    created() {
        this.DialogUpdateNickname = false,// 首次登录 修改
        console.log('关闭修改你呢');
    },
    methods:{
        DialogUpdateNicknameClose(){
          this.DialogUpdateNickname = false;
          this.reload()
        },
        open(){
          this.DialogUpdateNickname = true;
          console.log('打开修改昵称');
        },
        // 切换性别
        changeGenter(e){
            this.genderIndex = e
        },
        // 过滤关键字
        async blurinput(){
          if(this.updateNameValue && this.updateNameValue.length >0){
            // 查重----过滤关键字
            let keyWord = await  this.$store.dispatch('fifWord',{key:"userNamelist",value:this.updateNameValue})
            if(keyWord.state){
              this.updateNameValue = keyWord.value;
            }else{
              this.isbtn = false;
              return
            }
          }
          this.isbtn = true;
        },
        //   修改名字
       async UpdataName(e){
         if(this.isbtn){
           let resultEx =  await modifyEx({
               gender:this.genderIndex
             });
             let resultName = await modifyNickname({
               nickname: this.updateNameValue
             })
             if(resultName.data.code == 200){
               this.$message({
                 message: '昵称修改成功，请等待审核',
                 type: "success",
               });
                this.reload()
               this.DialogUpdateNickname = false;
             }
           console.log('', this.updateNameValue,resultName,resultEx);
         }
        }
    }
}
</script>
<style lang="scss" scoped>
     /deep/ .DialogScopeOver{
    width: 286px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.3000);
    border-radius: 20px;

    .dialog-footer{
      display:flex;
      justify-content: center;
      .greey{
        background: #999;
      }
    }
    .summat:active{
      opacity: .8;
      transition: all .3s;
    }
    .summat{
      width: 180px;
      cursor: pointer;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #721EDC;
      border-radius: 27px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
    .DialogrightClose{
      cursor: pointer;
      text-align: right;
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 14px;
    }
    .DialogTitle{
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .contentVal{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;

      .formData{
          display: flex;
          flex-direction: column;
        .formItems{
          display: flex;
          align-items: center;
          margin-top: 24px;
          .changegender{
            display: flex;
            .genderBox{
              display: flex;
              margin-right: 60px;
              align-items: center;
              cursor: pointer;
              span{
                height: 16px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 16px;
              }
              .headerimg{
                width: 50px;
                height: 50px;
                margin-right: 22px;
                position: relative;
                .defaultsel{
                  position: absolute;
                  bottom:0px;
                  right:-5px;
                  width: 20px;
                  height: 20px;
                }
                .default{
                   width: 50px;
                height: 50px;
                }
              }
            }
          }
          .myinput{
            width: 353px;
            height: 44px;
            background: #FFFFFF;
            border-radius: 44px;
            // border: 1px solid #DADADA;
            /deep/ input{
              border-radius: 44px;
              height: 44px;
            }
          }
          .nickNameLeft{
            width: 80px;
            text-align: center;
            height: 16px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 16px;


          }
        }
      }
      .headerTopbox{
        display: flex;
        img{
          width: 80px;
          height: 80px;
          margin-right: 12px;
        }
        .discript{
          margin-top: 6px;
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 14px;
        }
        .topTitle{
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          .title{
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_updataNickName.vue